'use strict';

const processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./contact/contact'));
});
